// extracted by mini-css-extract-plugin
export default {"rent":"Rent_rent__Zr7zH"};